export const BREAKPOINTS_NAMES = ['xl', 'lg', 'md', 'sm', 'xs', 'xxs'] as const;
export type BreakpointSizesType = typeof BREAKPOINTS_NAMES[number];
export type BreakpointOffsetsType =
  | 'xxsOffset'
  | 'xsOffset'
  | 'smOffset'
  | 'mdOffset'
  | 'lgOffset'
  | 'xlOffset';

export type BreakpointsType = { [k in BreakpointSizesType]: number };

export type ColBreakpointProps = {
  [k in BreakpointSizesType | BreakpointOffsetsType]?: number | 'auto';
};

export type ColExtendedProps = {
  cols?: number;
};

export type ColProps = ColBreakpointProps & ColExtendedProps;

export type RowProps = {
  cols?: number;
  gutter?: number;
  maxWidth?: number;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
};

export const breakpoints: BreakpointsType = {
  xxs: 0,
  xs: 375,
  sm: 667,
  md: 1280,
  lg: 1440,
  xl: 1920,
};